import type { SyntheticEvent } from 'react';
import { API_URL } from '@/shared/services/authServices';

// Imagem de NOTICIA passando pelo redimensionador da API (/api/img).
//
// O marketing cadastra a noticia colando a URL da imagem (postimg.cc etc.), e
// ela vem pesada (PNG de 2-3 MB): o site baixava o original ate' pra um card
// pequeno. A API baixa uma vez, reduz pra `width` e entrega WebP com cache
// longo (Cloudflare guarda na borda).
//
// So' URL externa (http/https) passa pelo redimensionador; asset local
// (/assets/...) volta como esta'.
//
// Imagem enviada pelo painel (POST /admin/news/upload, Cabal Next): a noticia
// guarda "/news-img/<nome>", arquivo no disco do host da API servido pelo nginx.
// O site roda em outro dominio -> completa com a origem da API (API_URL sem o
// "/api"; no painel do host, API_URL = "/api" -> mesma origem). Vai direto, sem
// o redimensionador.
const API_ORIGIN = API_URL.replace(/\/api\/?$/, '');

export function newsImgSrc(url: string | null | undefined): string {
  if (url && url.startsWith('/news-img/')) return `${API_ORIGIN}${url}`;
  return url ?? '';
}

export function newsImg(url: string | null | undefined, width: number): string {
  if (url && url.startsWith('/news-img/')) return newsImgSrc(url);
  if (!url || !/^https?:\/\//i.test(url)) return url ?? '';
  // base64 url-safe, sem padding (o formato que a rota espera)
  const key = btoa(unescape(encodeURIComponent(url)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  return `${API_URL}/img/${width}/${key}.webp`;
}

// onError do <img>: se o redimensionador falhar (host fora, formato estranho),
// cai pra URL original UMA vez -- a noticia nunca fica sem imagem.
export function newsImgFallback(original: string | null | undefined) {
  return (e: SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    if (!original || img.dataset.fallback) return;
    img.dataset.fallback = '1';
    img.src = newsImgSrc(original);
  };
}
